import React from 'react';
import axios from 'axios';
import { Form, Input, Button, Card, DatePicker, Popconfirm, Checkbox, notification } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import withSpin from 'components/withSpin';
import CardListForm from 'components/CardListForm';
import OtherSelect from 'components/OtherSelect';
import formItemLayout from 'components/Portal/formItemLayout';
const narrowItemLayout = Object.assign({}, formItemLayout, {labelCol: {sm: {span: 14}}, wrapperCol: {sm: {span: 10}}});

class AllergyForm extends React.Component {
	state = {
		showReactionDate: false,
		boxHasBeenUnchecked: false
	}
	checkIfShowReactionDate = (props) => {
		this.setState({
			showReactionDate: props.allergy.rmkDate1 != null || props.allergy.date != null
		});
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (err) return console.error(err);
			this.props.onSave(this.props.allergy.index, values);
		});
	}
	componentDidMount() { this.checkIfShowReactionDate(this.props); }
	render() {
		const { getFieldDecorator } = this.props.form;
		let {
			AssignId, Comments, rmkString1, rmkString2, rmkDate1, index,
			id, comments, allergen, reaction, date, saved
		} = this.props.allergy;
		if (!AssignId) AssignId = id;
		if (!Comments) Comments = comments;
		if (!rmkString1) rmkString1 = allergen;
		if (!rmkString2) rmkString2 = reaction;
		if (!rmkDate1) rmkDate1 = date;
		const disabled = saved || this.props.sectionDisabled;
		return (
			<Card>
				<Form onSubmit={this.handleSubmit}>
					{disabled && !this.props.sectionDisabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Button icon="edit" onClick={this.props.onEdit.bind(this, this.props.allergy.index)}>Edit</Button>
						</Form.Item>
					}
					{!disabled &&
						<Form.Item style={{textAlign:'right'}}>
							<Popconfirm title="Are you sure?" okText="Remove" cancelText="Cancel"
								onConfirm={this.props.onRemove.bind(this, this.props.allergy.index)}>
								<Button type="danger" size="large" icon="delete">Remove</Button>
							</Popconfirm>
							<Button type="primary" htmlType="submit" icon="save">Save</Button>
						</Form.Item>
					}
					<Form.Item label="Allergen" {...formItemLayout}>
						{getFieldDecorator('allergen', {
							initialValue: rmkString1,
							rules: [
								{required: true},
								{max: 50, message: 'Allergen is too long (50 characters max)'}
							]
						})(
							<Input placeholder="bee stings, latex, penicillin, peanuts, etc." disabled={disabled} />
						)}
					</Form.Item>
					<Form.Item label="Reaction" {...formItemLayout}>
						{getFieldDecorator('reaction', {
							initialValue: rmkString2,
							rules: [
								{required: true},
								{max: 50, message: 'Reaction is too long (50 characters max)'}
							]
						})(
							<Input placeholder="hives, headache, stomach upset, trouble breathing, etc." disabled={disabled} />
						)}
					</Form.Item>
					<Form.Item label="Causes an anaphylactic reaction" {...narrowItemLayout}>
						{getFieldDecorator('causesReaction', {
							valuePropName: 'checked',
							initialValue: rmkDate1 != null,
							onChange: (event) => {
								let s = {showReactionDate: event.target.checked};
								if (!event.target.checked) s.boxHasBeenUnchecked = true;
								this.setState(s);
							}
						})(
							<Checkbox disabled={disabled} />
						)}
					</Form.Item>
					{this.state.showReactionDate &&
						<Form.Item label="Date of last anaphylactic reaction"
							help="Note, participants must supply their own epinephrine" {...narrowItemLayout}>
							{getFieldDecorator('date', {
								initialValue: (rmkDate1 && !this.state.boxHasBeenUnchecked) ? moment(rmkDate1) : null,
								rules: [{required: true}]
							})(
								<DatePicker disabled={disabled} />
							)}
						</Form.Item>
					}
					<Form.Item label="Comments" {...formItemLayout}>
						{getFieldDecorator('comments', {
							initialValue: Comments,
							rules: [{max: 200, message: 'Comments are too long (200 characters max)'}]
						})(
							<Input type="textarea" disabled={disabled} />
						)}
					</Form.Item>
					<Form.Item>
						{getFieldDecorator('id', {
							initialValue: AssignId
						})(
							<Input type="hidden" />
						)}
					</Form.Item>
					<Form.Item>
						{getFieldDecorator('index', {
							initialValue: index
						})(
							<Input type="hidden" />
						)}
					</Form.Item>
				</Form>
			</Card>
		);
	}
}
const WrappedAllergyForm = Form.create()(AllergyForm);

class Allergies extends React.Component {
	state = {
		allergies: [],
		allergiesSet: false
	}
	handleChange = (s) => {
		this.setState(s);
	}
	handleSave = (allergy, s, index) => {
		this.props.isLoading();
		let submitAllergy = Object.assign({}, allergy);
		axios({
			method: (submitAllergy.id) ? 'put' : 'post',
			url: apiPath+'/remark/13',
			data: submitAllergy,
			withCredentials: true
		}).then(result => {
			if (!submitAllergy.id) s.allergies[index].AssignId = result.data.FolioList.Folio.AssignId;
			this.props.isDoneLoading();
			this.setState(s);
		}).catch(error => {
			this.props.isDoneLoading();
			this.props.handleAxiosSaveError(error);
		});
	}
	handleRemove = (allergy, s) => {
		if (!allergy.AssignId) return this.setState(s);
		this.props.isLoading();
		axios.delete(apiPath+'/remark/'+allergy.AssignId, {withCredentials: true})
			.then(result => {
				this.props.isDoneLoading();
				this.setState(s);
			}).catch(error => {
				this.props.isDoneLoading();
				notification.error({
					message: error.message,
					duration: 0
				});
				console.error(error);
			});
	}
	getAllergiesFromProps = (props) => {
		if (!this.state.allergiesSet && props.remarksLoaded) {
			this.setState({
				allergiesSet: true,
				allergies: props.remarks
					.filter(remark => remark.Code === 'ALL')
					.map(allergy => { allergy.saved = true; return allergy })
			});
		}
	}
	componentDidMount() {
		this.props.refreshRemarks().then(result => {this.getAllergiesFromProps(this.props);});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'health/allergies');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'health/allergies');
			if (redirect) return redirect;
		}

		let i = -1;
		return (
			<div className="withSpacing">
				<p>
					Please note: The information you submitted in your medical history form is confidential and not shared with the Field Office.
					If you would like the Field Office (including partner organizations and Trip Liaisons) to know about an allergy, please indicate so here.
					SAS will support participants in communicating, advocating and planning for their needs, but given the unique nature of the program, we cannot guarantee an environment free of all potential allergens. 
					<br /><br />
					Concerned participants should contact SAS to discuss a plan for success: <a href="mailto:Field@isevoyages.org">Field@isevoyages.org</a>
				</p>
				<CardListForm title="Allergy" thing="allergies" allergies={this.state.allergies} disabled={disabled}
					onChange={this.handleChange} onSave={this.handleSave} onRemove={this.handleRemove}>
					{this.state.allergies.map(allergy => {
						i++;
						allergy.index = i;
						let key = i;
						if (allergy.AssignId) key += '_'+allergy.AssignId;
						return (
							<WrappedAllergyForm key={key} allergy={allergy} sectionDisabled={disabled} />
						);
					})}
				</CardListForm>
			</div>
		);
	}
}

export default withSpin(Allergies);



// WEBPACK FOOTER //
// ./portal-components/Portal/Health/Allergies.jsx